<template>
  <div class="hb-user-profile-edit-page">
    <div id="user-profile-content">
      <UserProfileHeader title="学术项目" :required="true" desc="按照时间倒叙添加" />
      <div style="display: flex;flex-direction: row; align-items: center;column-gap: 10px;">
        <el-link
          @click="() => { previewUrl = 'https://ielts-refactor.oss-cn-chengdu.aliyuncs.com/other_file/F919471706618748.jpg'; previewName = '各类型论文介绍' }"
          type="primary">各类型论文介绍</el-link>
        <el-link
          @click="() => { previewUrl = 'https://ielts-refactor.oss-cn-chengdu.aliyuncs.com/other_file/F924777561619789.pdf'; previewName = '各类型科研介绍' }"
          type="primary">各类型科研介绍</el-link>
      </div>
      <el-card class="box-card" :id="'academic_projects_targetNode_' + item.user_information_id" style="width: 100%"
        v-for="(item, index) in profile.academic_projects">
        <div style="display: flex;align-items: center">
          <el-popconfirm title="是否确认删除？" @confirm="delAcademicProjects(index)">
            <el-link slot="reference" type="primary" data-html2canvas-ignore="true">删除</el-link>
          </el-popconfirm>
          <el-button type="primary" size="mini" style="margin-left: 15px"
            v-if="item.hidden_status == 2 || !item.hidden_status" @click="item.hidden_status = 1">隐藏</el-button>
          <el-button type="primary" size="mini" style="margin-left: 15px" v-if="item.hidden_status == 1"
            @click="item.hidden_status = 2">显示</el-button>
        </div>
        <p>学术项目：{{ index + 1 }} <span v-if="item.hidden_status === 1">【{{ item.name }}】</span> </p>
        <div v-if="item.hidden_status === 2">
          <el-descriptions class="margin-top" :column="2" border style="margin-top: 15px">
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label">
                <span style="color: red">*</span>类型
              </template>
              <div>
                <el-select v-model="item.type" placeholder="请选择">
                  <el-option v-for="item in academic_projects_list" :label="item" :value="item" :key="item"></el-option>
                </el-select>
              </div>
            </el-descriptions-item>
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label">
                <span style="color: red">*</span>时间
              </template>
              <div>
                <el-date-picker style="width: 450px" v-model="item.time" type="monthrange" range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期"
                  @change="changeMonth(item.user_information_id, 'academic_projects')">
                </el-date-picker>
              </div>
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions class="margin-top" :column="1" border style="margin-bottom: 15px">
            <el-descriptions-item :labelStyle="secondlabel" v-if="item.type == '比赛'">
              <template slot="label">
                <span style="color: red">*</span>比赛类型
              </template>
              <div>
                <el-select v-model="item.competition_type" placeholder="请选择">
                  <el-option v-for="item in competition_list" :label="item" :value="item" :key="item"></el-option>
                </el-select>
              </div>
            </el-descriptions-item>
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label">
                <span style="color: red">*</span>{{ academic_projects_placeholder_type_name(item.type).outcome }}
              </template>
              <el-input placeholder="项目名称" v-model="item.name" style="width: 80%; margin: 0 15px">
              </el-input>
            </el-descriptions-item>
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label">
                <div>
                  项目描述<span class="el-icon-question" @click="
                    requirmentDialog = academic_projects_placeholder(
                      item.type
                    ).desc
                    "></span>
                </div>
              </template>
              <el-input :rows="4" type="textarea" v-model="item.describe" placeholder="填写前请点击问号查看要求"
                autosize></el-input>
            </el-descriptions-item>
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label">
                <!--              最终结果-->
                <span>{{ academic_projects_placeholder_type(item.type).outcome }}</span>
              </template>
              <el-input type="textarea" v-model="item.outcome"
                :placeholder="academic_projects_placeholder(item.type).outcome" autosize></el-input>
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions class="margin-top" :column="1" border style="margin-bottom: 15px">
            <el-descriptions-item :labelStyle="secondlabel" label="附件">
              <elevenUpdate :fileList="item.fileList" :item="item" @url_data="getUrl" />
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </el-card>
      <div style="text-align: left; margin-top: 20px" data-html2canvas-ignore="true">
        <el-button plain @click="addAcademicProjects">增加</el-button>
      </div>
      <UserProfileHeader title="实习/工作经历" link="证明模板下载>" @link_url="link_url" :required="true" desc="按照时间倒叙添加" />
      <el-card class="box-card" :id="'work_experience_targetNode_' + item.user_information_id" style="width: 100%"
        v-for="(item, index) in profile.work_experience">
        <div style="display: flex;align-items: center">
          <el-popconfirm title="是否确认删除？" @confirm="delWorkExperience(index)">
            <el-link slot="reference" type="primary" data-html2canvas-ignore="true">删除</el-link>
          </el-popconfirm>
          <el-button type="primary" size="mini" style="margin-left: 15px"
            v-if="item.hidden_status == 2 || !item.hidden_status" @click="item.hidden_status = 1">隐藏</el-button>
          <el-button type="primary" size="mini" style="margin-left: 15px" v-if="item.hidden_status == 1"
            @click="item.hidden_status = 2">显示</el-button>
        </div>
        <p>工作经历：{{ index + 1 }} <span v-if="item.hidden_status === 1">【{{ item.corporation_name }}】</span></p>
        <div v-if="item.hidden_status === 2">
          <el-descriptions class="margin-top" :column="2" border style="margin-top: 15px">
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"><span style="color: red">*</span> 公司
              </template>
              <div>
                <el-input placeholder="公司名称" v-model="item.corporation_name">
                </el-input>
              </div>
            </el-descriptions-item>

            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"> 公司英文名称
              </template>
              <div>
                <el-input placeholder="公司名称" v-model="item.corporation_ename">
                </el-input>
              </div>
            </el-descriptions-item>

            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"><span style="color: red">*</span> 类型
              </template>
              <div>
                <el-select v-model="item.type" placeholder="请选择">
                  <el-option v-for="item in work_experience_list" :label="item" :value="item" :key="item"></el-option>
                </el-select>
              </div>
            </el-descriptions-item>
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"><span style="color: red">*</span> 职位
              </template>
              <div>
                <el-input placeholder="职位" v-model="item.position"> </el-input>
              </div>
            </el-descriptions-item>
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"><span style="color: red">*</span> 时间
              </template>
              <div>
                <el-date-picker style="width: 450px" v-model="item.time" type="monthrange" value-format="yyyy-MM-dd"
                  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                  @change="changeMonth(item.user_information_id, 'work_experience')">
                </el-date-picker>
              </div>
            </el-descriptions-item>
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"> 公司网址 </template>
              <el-input placeholder="公司网址" v-model="item.company_address"> </el-input>
            </el-descriptions-item>
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"><span style="color: red">*</span> 公司地址 </template>
              <el-input placeholder="公司地址" v-model="item.corporation_address">
              </el-input>
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions class="margin-top" :column="1" border style="margin-bottom: 15px">
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"> 负责内容 </template>
              <el-input type="textarea" v-model="item.responsibility"
                :placeholder="work_experience_placeholder().responsibility" autosize></el-input>
            </el-descriptions-item>

          </el-descriptions>
          <el-descriptions class="margin-top" :column="1" border style="margin-bottom: 15px">
            <el-descriptions-item :labelStyle="secondlabel" label="附件">
              <elevenUpdate :fileList="item.fileList" :item="item" @url_data="getUrl" />
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </el-card>
      <div style="text-align: left; margin-top: 20px" data-html2canvas-ignore="true">
        <el-button plain @click="addWorkExperience">增加</el-button>
      </div>

      <!-- 项目经历 -->
      <UserProfileHeader title="项目经历" desc="请按照时间倒叙添加"/>
      <el-card class="box-card" :id="'xiangmu_experience_targetNode_' + index" style="width: 100%"
        v-for="(item, index) in profile.xiangmu_experience">
        <div style="display: flex;align-items: center">
          <el-popconfirm title="是否确认删除？" @confirm="delXiangmuExperience(index)">
            <el-link slot="reference" type="primary" data-html2canvas-ignore="true">删除</el-link>
          </el-popconfirm>
          <el-button type="primary" size="mini" style="margin-left: 15px"
            v-if="item.hidden_status == 2 || !item.hidden_status" @click="item.hidden_status = 1">隐藏</el-button>
          <el-button type="primary" size="mini" style="margin-left: 15px" v-if="item.hidden_status == 1"
            @click="item.hidden_status = 2">显示</el-button>
        </div>
        <p>项目经历：{{ index + 1 }} <span v-if="item.hidden_status === 1">【{{ item.corporation_name }}】</span></p>
        <div v-if="item.hidden_status === 2">
          <el-descriptions class="margin-top" :column="2" border style="margin-top: 15px">
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"><span style="color: red">*</span> 项目名称
              </template>
              <div>
                <el-input placeholder="项目名称" v-model="item.corporation_name">
                </el-input>
              </div>
            </el-descriptions-item>
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"><span style="color: red">*</span> 类型
              </template>
              <div>
                <el-select v-model="item.type" placeholder="请选择">
                  <el-option v-for="item in ['实地','线上']" :label="item" :value="item" :key="item"></el-option>
                </el-select>
              </div>
            </el-descriptions-item>
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"><span style="color: red">*</span> 职位
              </template>
              <div>
                <el-input placeholder="职位" v-model="item.position"> </el-input>
              </div>
            </el-descriptions-item>

            <!-- <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label">公司英文名称
              </template>
              <div>
                <el-input placeholder="公司英文名称" v-model="item.corporation_ename">
                </el-input>
              </div>
            </el-descriptions-item>

            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"><span style="color: red">*</span> 类型
              </template>
              <div>
                <el-select v-model="item.type" placeholder="请选择">
                  <el-option v-for="item in work_experience_list" :label="item" :value="item" :key="item"></el-option>
                </el-select>
              </div>
            </el-descriptions-item>
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"><span style="color: red">*</span> 职位
              </template>
              <div>
                <el-input placeholder="职位" v-model="item.position"> </el-input>
              </div>
            </el-descriptions-item> -->
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"><span style="color: red">*</span> 时间
              </template>
              <div>
                <el-date-picker style="width: 300px" v-model="item.time" type="monthrange" value-format="yyyy-MM-dd"
                  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                  @change="changeMonth(item.user_information_id, 'work_experience')">
                </el-date-picker>
              </div>
            </el-descriptions-item>

            <!-- <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"> 公司网址 </template>
              <el-input placeholder="公司网址" v-model="item.company_address"> </el-input>
            </el-descriptions-item>

            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"> 公司地址 </template>
              <el-input placeholder="公司地址" v-model="item.corporation_address">
              </el-input>
            </el-descriptions-item> -->
          </el-descriptions>
          <el-descriptions class="margin-top" :column="1" border style="margin-bottom: 15px">
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"> <span style="color: red">*</span>负责内容 </template>
              <el-input type="textarea" v-model="item.responsibility"
                :placeholder="work_experience_placeholder().responsibility" autosize></el-input>
            </el-descriptions-item>

          </el-descriptions>
          <!-- <el-descriptions class="margin-top" :column="1" border style="margin-bottom: 15px">
            <el-descriptions-item :labelStyle="secondlabel" label="附件">
              <elevenUpdate :fileList="item.fileList" :item="item" @url_data="getUrl" />
            </el-descriptions-item>
          </el-descriptions> -->
        </div>
      </el-card>
      <div style="text-align: left; margin-top: 20px" data-html2canvas-ignore="true">
        <el-button plain @click="addXiangmuExperience">增加</el-button>
      </div>



      <UserProfileHeader title="荣誉奖励" />
      <el-card class="box-card" :id="'honorary_rewards_targetNode_' + item.user_information_id" style="width: 100%"
        v-for="(item, index) in profile.honorary_rewards">
        <div style="display: flex;align-items: center">
          <el-popconfirm title="是否确认删除？" @confirm="delHonoraryRewards(index)">
            <el-link slot="reference" type="primary" data-html2canvas-ignore="true">删除</el-link>
          </el-popconfirm>
          <el-button type="primary" size="mini" style="margin-left: 15px"
            v-if="item.hidden_status == 2 || !item.hidden_status" @click="item.hidden_status = 1">隐藏</el-button>
          <el-button type="primary" size="mini" style="margin-left: 15px" v-if="item.hidden_status == 1"
            @click="item.hidden_status = 2">显示</el-button>
        </div>
        <p>荣誉奖励：{{ index + 1 }}<span v-if="item.hidden_status === 1">【{{ item.name }}】</span></p>
        <div v-if="item.hidden_status === 2">
          <el-descriptions class="margin-top" :column="1" border>
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"> 名称 </template>
              <el-input type="text" v-model="item.name"></el-input>
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions :column="2" border>
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"> 类型 </template>
              <div>
                <el-select v-model="item.type" placeholder="请选择">
                  <el-option v-for="item in honorary_rewards_list" :label="item" :value="item" :key="item"></el-option>
                </el-select>
              </div>
            </el-descriptions-item>
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"> 时间 </template>
              <el-date-picker style="width: 450px" v-model="item.time" type="monthrange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期"
                @change="changeMonth(item.user_information_id, 'honorary_rewards')">
              </el-date-picker>
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions :column="1" border>
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"> 描述 </template>
              <el-input type="textarea" v-model="item.content" autosize></el-input>
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </el-card>
      <div style="text-align: left; margin-top: 20px" data-html2canvas-ignore="true">
        <el-button plain @click="addHonoraryRewards">增加</el-button>
      </div>
      <UserProfileHeader title="课外活动" :required="true" />
      <el-card class="box-card" :id="'extracurricular_activities_targetNode_' + item.user_information_id"
        style="width: 100%" v-for="(item, index) in profile.extracurricular_activities">
        <div style="display: flex;align-items: center">
          <el-popconfirm title="是否确认删除？" @confirm="delExtracurricularActivities(index)">
            <el-link slot="reference" type="primary" data-html2canvas-ignore="true">删除</el-link>
          </el-popconfirm>
          <el-button type="primary" size="mini" style="margin-left: 15px"
            v-if="item.hidden_status == 2 || !item.hidden_status" @click="item.hidden_status = 1">隐藏</el-button>
          <el-button type="primary" size="mini" style="margin-left: 15px" v-if="item.hidden_status == 1"
            @click="item.hidden_status = 2">显示</el-button>
        </div>
        <p>课外活动：{{ index + 1 }} <span v-if="item.hidden_status === 1">【{{ item.name }}】</span></p>
        <div v-if="item.hidden_status === 2">
          <el-descriptions class="margin-top" :column="1" border>
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label">
                <span style="color: red">*</span>名称
              </template>
              <el-input v-model="item.name"></el-input>
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions :column="2" border>
            <el-descriptions-item>
              <template slot="label">
                <span style="color: red">*</span>是否有证书
              </template>
              <el-radio-group v-model="item.certificate">
                <el-radio :label="1">有</el-radio>
                <el-radio :label="2">无</el-radio>
              </el-radio-group>
            </el-descriptions-item>
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label">
                <span style="color: red">*</span>时间
              </template>
              <el-date-picker style="width: 450px" v-model="item.time" type="monthrange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期"
                @change="changeMonth(item.user_information_id, 'extracurricular_activities')">
              </el-date-picker>
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions :column="1" border>
            <el-descriptions-item :labelStyle="secondlabel">
              <template slot="label"> 内容 </template>
              <el-input type="textarea" v-model="item.content" placeholder="国际公务员，暑校，志愿者，社团，拍摄微电影等" autosize></el-input>
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </el-card>
      <div style="text-align: left; margin-top: 20px" data-html2canvas-ignore="true">
        <el-button plain @click="addExtracurricularActivities">增加</el-button>
      </div>

      <UserProfileHeader title="个人技能" desc="" />
      <div v-for="(tag, index) in profile.user_evaluate.dynamicTags">
        <div class="dynamicTags">
          <div class="icon">
            <el-popconfirm title="是否删除该数据？" @confirm="handleClose(tag)">
              <i slot="reference" class="el-icon-remove" style="color: #f56c6c" />
            </el-popconfirm>
          </div>
          <div style="display: flex;flex-direction: column;align-items: start;">
            <div style="margin-bottom: 5px;"><el-tag>{{ handleJinengTag(tag).tag }}</el-tag> {{
              handleJinengTag(tag).content
              }}</div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <!-- <p>
        <el-input v-if="skill_editing" v-model="skill_inputValue" @blur="handleBlur" ref="skillEditInput"></el-input>
      </p> -->
      <el-button plain @click="addDynamicTags">增加</el-button>
      <UserProfileHeader title="自我评价" />
      <el-descriptions class="margin-top" :column="2" border>
        <el-descriptions-item labelStyle="border:none;padding:0" :content-style="secondContTwo">
          <el-input type="textarea" v-model="profile.user_evaluate.appraise" rows="3"
            placeholder="2点关于自己，例如团队协作，亲和力强等；2点关于申请的专业，例如申请data science，对数据敏感，逻辑性强等"></el-input>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <HBFixedButton @click="submitProfile" v-loading.fullscreen.lock="from_loading"
      :desc="infoStatusDesc(study_abroad_information_status)" />

    <el-dialog title="新增技能" :visible.sync="DialogSon" width="50%" center :append-to-body="true"
      :close-on-click-modal="false" @close="inputValueTagType = ''; inputValue = '';">
      <el-form label-position="top" ref="teacherFrom" size="small" label-width="120px" style="margin: 0">
        <el-form-item required label="技能类型">
          <!-- <el-input   type="textarea" :rows="4" v-model="inputValue"></el-input> -->
          <el-select v-model="inputValueTagType" placeholder="请选择">
            <el-option
              v-for="item in [{ label: '计算机技能', value: '计算机技能' }, { label: '实验技能', value: '实验技能' }, { label: '研究技能', value: '研究技能' }, { label: '量化技能', value: '量化技能' }, { label: '其他', value: '其他' }]"
              :label="item.label" :value="item.value" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item required label="技能描述">
          <el-input type="textarea" :rows="4" v-model="inputValue"></el-input>
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button @click="DialogSon = false" size="small" style="margin-right: 1rem">取消</el-button>
          <el-button type="primary" size="small" @click="onSubmit()">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="填写要求" :visible.sync="requirmentDialog" width="50%" center>
      <p style="font-weight: 550;color: #333; white-space: pre-wrap;">{{ requirmentDialog }}</p>
    </el-dialog>
    <el-dialog title="证明模板" :visible.sync="dialogTemplate" width="50%" center destroy-on-close>
      <p>
        <el-link :underline="false" type="primary" @click="() => { previewUrl = TemplateUrl1; previewName = '工作证明.docx' }">
          工作证明 预览下载>
        </el-link>
      </p>
      <p>
        <el-link :underline="false" type="primary" @click="() => { previewUrl = TemplateUrl2; previewName = '实习证明1.docx' }">
          实习证明1 预览下载>
        </el-link>
      </p>
      <p>
        <el-link :underline="false" type="primary" @click="() => { previewUrl = TemplateUrl3; previewName = '实习证明2.docx' }">
          实习证明2 预览下载>
        </el-link>
      </p>
      <p>
        <el-link :underline="false" type="primary" @click="() => { previewUrl = TemplateUrl4; previewName = '实习证明3.docx' }">
          实习证明3 预览下载>
        </el-link>
      </p>
    </el-dialog>

    <HBFilePreview :previewUrl="previewUrl" :fileName="previewName" @updateVisible="previewUrl = null; previewName = null" />

  </div>
</template>
<script>
import elevenUpdate from "./tab_eleven_update.vue";
import address_view from "./address_view.vue";
import UserProfileHeader from "./userprofile_header.vue";
import { profile_list, profile_update } from "@/api/mycenter_studyabroad";
import HBRadioGroupDialog from "../HBCommon/HBRadioGroupDialog/HBRadioGroupDialog";
import HBFixedButton from "../HBCommon/HBFixedButton/HBFixedButton";
import { infoStatusDesc } from "../HBCommon/util";
import {
  academic_projects_placeholder_type,
  academic_projects_placeholder_type_name,
  academic_projects_placeholder,
  work_experience_placeholder,
} from "../HBCommon/placeholder";
import { kCacheAbroadInfos } from "../tool";
import HBFilePreview from '@/components/HBCommon/HBFilePreview/HBFilePreview';

export default {
  name: "TabEleven",
  components: {
    elevenUpdate,
    address_view,
    UserProfileHeader,
    HBRadioGroupDialog,
    HBFixedButton,
    HBFilePreview
  },
  data() {
    // 身份证验证
    var validatorIdCard = (rule, value, callback) => {
      // 地区
      var aCity = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外",
      };
      // 验证长度
      if (!/^\d{17}(\d|x)$/i.test(value)) {
        callback(
          new Error("您输入的身份证号长度或格式错误，请输入正确的身份证号")
        );
        return;
      }
      // 验证前两位是否为省份代码
      value = value.replace(/x$/i, "a");
      if (aCity[parseInt(value.substr(0, 2))] == null) {
        callback(
          new Error("您输入的身份证号长度或格式错误，请输入正确的身份证号")
        );
        return;
      }
      // 身份证上的出生年月校验
      var sBirthday =
        value.substr(6, 4) +
        "-" +
        Number(value.substr(10, 2)) +
        "-" +
        Number(value.substr(12, 2));
      var d = new Date(sBirthday.replace(/-/g, "/"));
      if (
        sBirthday !=
        d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()
      ) {
        callback(new Error("您输入的身份证号不合法，请输入正确的身份证号"));
        return;
      }
      // 身份证校验位判断
      var iSum = 0;
      for (var i = 17; i >= 0; i--) {
        iSum += (Math.pow(2, i) % 11) * parseInt(value.charAt(17 - i), 11);
      }
      if (iSum % 11 != 1) {
        callback(new Error("您输入的身份证号不合法，请输入正确的身份证号"));
        return;
      }
      callback();
    };
    return {
      fileList: [],
      previewUrl: null,
      previewName: null,
      TemplateUrl1: 'https://ielts-refactor.oss-cn-chengdu.aliyuncs.com/admin_file/E326376947316242.docx',
      TemplateUrl2: 'https://ielts-refactor.oss-cn-chengdu.aliyuncs.com/admin_file/E326378627579641.docx',
      TemplateUrl3: 'https://ielts-refactor.oss-cn-chengdu.aliyuncs.com/admin_file/E326378841826627.docx',
      TemplateUrl4: 'https://ielts-refactor.oss-cn-chengdu.aliyuncs.com/admin_file/E326379000464130.docx',
      dialogTemplate: false,
      requirmentDialog: false,
      defaultProfileData: [],
      radioGroupDialogFlag: false,
      radioGroupDialogDatasource: [],
      from_loading: false,
      DialogSon: false,
      user_bind_info: {},
      birthplace_arr: "",
      home_address_arr: "",
      home_address_with: "width: 45%",
      rowCenter: { "text-align": "center" },
      birthplace_with: "width: 100%",
      secondlabel: {
        width: "120px",
        "text-align": "center",
      },
      secondCont: {
        width: "42%",
      },
      secondContTwo: {
        width: "240px",
        "text-align": "center",
      },
      sex: [
        { text: "男", value: "1" },
        { text: "女", value: "2" },
      ],
      child: [
        { text: "是", value: "1" },
        { text: "不是", value: "2" },
      ],
      education_level_list: ["初中", "高中", "大学", "其他"], // 学历
      nation_list: [
        "汉族",
        "蒙古族",
        "藏族",
        "苗族",
        "壮族",
        "回族",
        "维吾尔族",
        "彝族",
        "布依族",
        "朝鲜族",
        "侗族",
        "白族",
        "哈尼族",
        "傣族",
        "傈僳族",
        "畲族",
        "拉祜族",
        "满族",
        "瑶族",
        "土家族",
        "哈萨克族",
        "黎族",
        "佤族",
        "高山族",
        "水族",
        "东乡族",
        "景颇族",
        "土族",
        "仫佬族",
        "布朗族",
        "毛南族",
        "锡伯族",
        "普米族",
        "纳西族",
        "柯尔克孜族",
        "达斡尔族",
        "羌族",
        "撒拉族",
        "仡佬族",
        "阿昌族",
        "塔吉克族",
        "怒族",
        "俄罗斯族",
        "德昂族",
        "裕固族",
        "塔塔尔族",
        "鄂伦春族",
        "门巴族",
        "基诺族",
        "乌孜别克族",
        "鄂温克族",
        "保安族",
        "京族",
        "独龙族",
        "赫哲族",
        "珞巴族",
      ],
      // 种族
      race_list: [
        "Chinese",
        "Arab",
        "Asian or Asian British-Bangladeshi",
        "Asian or Asian British-Indian",
        "Asian or Asian British- Pakistani",
        "Black or Black British-African",
        "Black or Black British-Caribbean",
        "Gypsy or Traveller",
        "Information Refused",
        "Mixed-White and Asian",
        "Mixed-White and Black African",
        "Mixed-White and Black Caribbean",
        "Not Known",
        "Other Asian Background",
        "Other Black Background",
        "Other Ethnic Background",
        "Other Mixed Background",
        "White",
      ],
      language_achievement_and_account_secrecy_list: [
        "IELTS",
        "TOEFL",
        "GRE",
        "GMAT",
        "Duolingo",
        "朗思",
        "CET6",
        "IB",
        "A-LEVEL",
        "SAT",
        "ACT",
        "VCE",
      ],
      inputVisible: false,
      // 新增技能
      inputValueTagType: "",
      inputValue: "",
      // 荣誉奖励类型
      honorary_rewards_list: ["奖学金", "竞赛", "义工", "其他"],
      // 婚姻状况
      marriage_list: ["原配", "离异", "再婚", "丧偶"],
      // 阶段
      stage_list: ["本科", "硕士", "高中", "专科", "博士", "中专"],
      // 学位类型
      degree_type_list: ["第一学位", "第二学位", "辅修学位"],
      // 类型
      // exchange_experiences_type_list: ["夏校", "交换"],
      // 项目类型
      academic_projects_list: ['科研', "论文", "比赛", "课程",'Research'],
      // 比赛类型
      competition_list: ['互联网+', "挑战杯", "大创", "其他"],
      // 工作类型
      work_experience_list: ["全职", "实习", "实训", "兼职"],
      // 验证规则
      rules: {
        name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        sex: [{ required: true, message: "性别不能为空", trigger: "blur" }],
        birthday: [
          { required: true, message: "出生日期不能为空", trigger: "blur" },
        ],
        child: [{ required: true, message: "选项不能为空", trigger: "blur" }],
        nation: [
          { required: true, message: "民族不能为空", trigger: "change" },
        ],
        race: [{ required: true, message: "种族不能为空", trigger: "change" }],
        birthplace: [
          { required: true, message: "出生地不能为空", trigger: "blur" },
        ],
        postal_code: [
          { required: true, message: "邮政编码不能为空", trigger: "blur" },
        ],
        // id_card: [
        //   { required: true, validator: validatorIdCard, trigger: "blur" },
        // ],
      },
      study_abroad_information_status: 0,
      // 个人信息
      profile: {
        // 基本信息
        user_base: {
          user_information_id: "",
          race: "", // 种族
          name: "", // 姓名
          sex: "", //  性别
          birthday: "", // 出生日期
          birthplace: "", // 出生地
          child: "", // 是否是独生子女
          nation: "", // 民族
          postal_code: "", // 邮政编码
          id_card: "", // 身份证
        },
        // 自我评价
        user_evaluate: {
          user_information_id: "",
          dynamicTags: [],
          appraise: "",
        },
        // 标化成绩
        language_achievement_and_account_secrecy: {
          user_information_id: "",
          content: [],
        },
        // 教育经历
        educational_background: [],
        // 夏校/交换经历
        // exchange_experiences: [],
        // 学术/项目
        academic_projects: [],
        // 工作经历
        work_experience: [],
                // 项目经历
                xiangmu_experience: [],
        // 荣誉奖励
        honorary_rewards: [],
        // 论文
        thesis: [],
        // 课外活动
        extracurricular_activities: [],
        user_id: "",
        study_abroad_information_status: 0
      },
      is_assign_task_cv: '',
      is_assign_task_cv_list: [],
      skill_editing: '',
      skill_inputValue: '',
      skill_tagIndex: null
    };
  },
  created() {
    this.studentProfile();
  },
  methods: {
    handleJinengTag(tag) {
      console.log('tag', tag)
      // 判断tag是string还是object
      if (typeof tag === 'object' && tag !== null) {
        return tag
      } else {
        return {
          tag: '其他',
          content: tag
        }
      }
    },
    handleBlur() {
      if (!this.skill_inputValue) {
        this.$message.error('内容不能为空')
        return
      }
      this.saveEdit()
    },
    saveEdit() {
      let l = []
      let old_str = []
      let new_str = []
      this.profile.user_evaluate.dynamicTags.forEach((item, index) => {
        if (this.skill_tagIndex == index) {
          old_str = item
          new_str = this.skill_inputValue
          l.push(this.skill_inputValue)
        } else {
          l.push(item)
        }
      })
      this.profile.user_evaluate.dynamicTags = l
      this.skill_editing = false
    },
    handleDoubleClick(_tag, index) {
      this.skill_editing = true
      this.skill_inputValue = _tag
      this.skill_tagIndex = index
      this.$nextTick(() => {
        this.$refs.skillEditInput.focus()
      })
    },
    getUrl(val) {
      console.log('上传成功', val)
    },
    targetNode(index) {
      return 'targetNode_' + index
    },
    changeMonth(_user_information_id, _type) {
      this.month(_type)
      this.$forceUpdate()
      this.$nextTick(() => {
        const element = document.getElementById(_type + '_targetNode_' + _user_information_id)
        if (element) {
          // 使用原生的scrollIntoView方法来滚动到元素
          element.scrollIntoView({ behavior: 'smooth' })
        }
      })
    },
    month(_type) {
      let len = 0
      let arr = []
      if (_type === 'work_experience') {
        len = this.profile.work_experience.length
        arr = this.profile.work_experience
      }
      if (_type === 'xiangmu_experience') {
        len = this.profile.xiangmu_experience.length
        arr = this.profile.xiangmu_experience
      }
      if (_type === 'academic_projects') {
        len = this.profile.academic_projects.length
        arr = this.profile.academic_projects
      }
      if (_type === 'honorary_rewards') {
        len = this.profile.honorary_rewards.length
        arr = this.profile.honorary_rewards
      }
      if (_type === 'extracurricular_activities') {
        len = this.profile.extracurricular_activities.length
        arr = this.profile.extracurricular_activities
      }
      for (let i = 0; i < len; i++) {
        for (let j = 0; j < len - 1 - i; j++) {
          let time1
          if (!arr[j]['time'] || arr[j]['time'].length == 0) {
            time1 = 0
          } else {
            let date = new Date(arr[j]['time'][0])
            time1 = new Date(date).getTime()
          }
          let time2
          if (!arr[j + 1]['time'] || arr[j + 1]['time'].length == 0) {
            time2 = 0
          } else {
            let date2 = new Date(arr[j + 1]['time'][0])
            time2 = new Date(date2).getTime()
          }
          if (time1 < time2) {
            let temp = arr[j]
            arr[j] = arr[j + 1]
            arr[j + 1] = temp
          }
        }
      }
      if (_type === 'work_experience') {
        this.profile.work_experience = arr
      }
            
      if (_type === 'xiangmu_experience') {
        this.profile.xiangmu_experience = arr
      }
      if (_type === 'academic_projects') {
        this.profile.academic_projects = arr
      }
      if (_type === 'honorary_rewards') {
        this.profile.honorary_rewards = arr
      }
      if (_type === 'extracurricular_activities') {
        this.profile.extracurricular_activities = arr
      }
    },
    exportFile(data, fileName, _this) {
      // 地址不存在时，禁止操作
      if (!data) return;
      // 下载文件并保存到本地
      const callback = (data) => {
        // 创建a标签，使用 html5 download 属性下载，
        const link = document.createElement('a');
        // 创建url对象
        const objectUrl = window.URL.createObjectURL(new Blob([data]));
        link.style.display = 'none';
        link.href = objectUrl;
        // 自定义文件名称， fileName
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        // 适当释放url
        window.URL.revokeObjectURL(objectUrl);
      };
      // 把接口返回的url地址转换为 blob
      const xhr = new XMLHttpRequest();
      xhr.open('get', data, true);
      xhr.responseType = 'blob';
      xhr.onload = () => {
        // 返回文件流，进行下载处理
        callback(xhr.response);
      };
      xhr.send(); // 不要忘记发送
    },
    link_url() {
      this.dialogTemplate = true
    },
    infoStatusDesc(type) {
      return infoStatusDesc(type);
    },
    work_experience_placeholder() {
      return work_experience_placeholder();
    },
    academic_projects_placeholder_type(type) {
      return academic_projects_placeholder_type(type);
    },

    academic_projects_placeholder_type_name(type) {
      return academic_projects_placeholder_type_name(type);
    },
    academic_projects_placeholder(type) {
      return academic_projects_placeholder(type);
    },
    addDynamicTags() {
      this.DialogSon = true;
    },
    onSubmit() {
      var inputValue = this.inputValue;
      var inputValueTagType = this.inputValueTagType;

      if (!inputValue) {
        this.$message.error("请填技能描述");
        return;
      }
      if (!inputValueTagType) {
        this.$message.error("请选择技能类型");
        return;
      }

      this.profile.user_evaluate.dynamicTags.push({
        tag: inputValueTagType,
        content: inputValue
      });

      this.DialogSon = false;
      this.inputValue = "";
      this.inputValueTagType = "";
    },
    radioGroupDialogCallback(val) {
      this.submitData(val);
    },
    submitProfile() {
      this.$confirm("是否确认保存？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.submitData(this.study_abroad_information_status);
        })
        .catch(() => { });
    },
    submitData(val) {
      // if (
      //   this.profile.exchange_experiences.findIndex((item) => !item.school) >= 0
      // ) {
      //   this.$message.error("请完善夏校/交换经历");
      //   return;
      // }

      if (this.profile.academic_projects.findIndex((item) => !item.name) >= 0) {
        this.$message.error("请完善学术项目");
        return;
      }
      if (
        this.profile.work_experience.findIndex(
          (item) => !item.corporation_name
        ) >= 0
      ) {
        this.$message.error("请完善工作经历");
        return;
      }
      if (this.profile.honorary_rewards.findIndex((item) => !item.name) >= 0) {
        this.$message.error("请完善荣誉奖励");
        return;
      }
      if (this.profile.thesis.findIndex((item) => !item.name) >= 0) {
        this.$message.error("请完善论文");
        return;
      }
      if (
        this.profile.extracurricular_activities.findIndex(
          (item) => !item.name
        ) >= 0
      ) {
        this.$message.error("请完善课外活动");
        return;
      }

      var rdata = {};
      rdata.type = "cv";
      rdata.user_id = this.$route.query.userId;
      rdata.study_abroad_information_status = val;
      rdata.academic_projects = this.profile.academic_projects;
      rdata.extracurricular_activities =
        this.profile.extracurricular_activities;
      rdata.honorary_rewards = this.profile.honorary_rewards;
      rdata.thesis = this.profile.thesis;
      rdata.user_evaluate = this.profile.user_evaluate;
      rdata.work_experience = this.profile.work_experience;
      rdata.xiangmu_experience = this.profile.xiangmu_experience;
      // rdata.exchange_experiences = this.profile.exchange_experiences;
      this.from_loading = true;
      kCacheAbroadInfos(JSON.stringify(rdata));
      profile_update(rdata)
        .then((response) => {
          this.from_loading = false;
          if (response.code === 200) {
            this.$message({
              message: "保存成功",
              type: "success",
            });
            this.studentProfile();
          }
        })
        .catch((error) => {
          this.from_loading = false;
          this.$message({ message: error.message, type: "error" });
        });
    },
    checkMaterialsUploaded(id, next, specialClassName) {
      // 是否上传过材料
      var flag = false;
      if (this.defaultProfileData && this.defaultProfileData.length > 0) {
        if (specialClassName == "language_achievement_and_account_secrecy") {
          const specialClassObj = this.defaultProfileData.find(
            (obj) => obj.class == specialClassName
          );
          if (specialClassObj && specialClassObj.info) {
            // const conList = JSON.parse(specialClassObj.con).content || [];
            const index = specialClassObj.info.findIndex(
              (obj) => obj.id == id && obj.upload && obj.upload.length > 0
            );

            flag = index >= 0;
          }
        } else {
          var re = this.defaultProfileData.find((item) => item.id == id);
          if (re && re.info) {
            const index = re.info.findIndex(
              (d) => d.upload && d.upload.length > 0
            );
            flag = index >= 0;
          }
        }
      }
      if (flag) {
        this.$confirm(
          "当前模块已上传过申请材料，删除后将会移除对应的申请材料，是否继续？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            next();
          })
          .catch((e) => { });
      } else {
        next();
      }
    },
    studentProfile() {
      profile_list({ user_id: this.$route.query.userId })
        .then((response) => {
          this.defaultProfileData = response.data || [];
          var profile = this.profile;
          var home = [];
          profile.language_achievement_and_account_secrecy.content = [];
          profile.language_achievement_and_account_secrecy.user_information_id =
            "";
          profile.educational_background = [];
          // profile.exchange_experiences = [];
          profile.academic_projects = [];
          profile.work_experience = [];
          profile.xiangmu_experience = []
          profile.honorary_rewards = [];
          profile.thesis = [];
          profile.extracurricular_activities = [];
          // 获取个人绑定信息文稿状态
          if (
            response.data.length &&
            response.data[0].study_abroad_information_cv_status
          ) {
            this.study_abroad_information_status =
              response.data[0].study_abroad_information_cv_status.status;
          }
          response.data.forEach(function (item, index) {
            var content;
            content = JSON.parse(item.con);
            if (item.class === "other") {
              return;
            }
            if (item.class === "user_base") {
              if (content) {
                profile.user_base.user_information_id = item.id;
                if (content.race) {
                  profile.user_base.race = content.race;
                } else {
                  profile.user_base.race = "";
                }
                if (content.name) {
                  profile.user_base.name = content.name;
                } else {
                  profile.user_base.name = "";
                }
                if (content.sex) {
                  profile.user_base.sex = content.sex;
                } else {
                  profile.user_base.sex = "";
                }
                if (content.birthday) {
                  profile.user_base.birthday = content.birthday;
                } else {
                  profile.user_base.birthday = "";
                }
                if (content.birthplace) {
                  profile.user_base.birthplace = content.birthplace;
                } else {
                  profile.user_base.birthplace = "";
                }
                if (content.child) {
                  profile.user_base.child = content.child;
                } else {
                  profile.user_base.child = "";
                }
                if (content.nation) {
                  profile.user_base.nation = content.nation;
                } else {
                  profile.user_base.nation = "";
                }
                if (content.postal_code) {
                  profile.user_base.postal_code = content.postal_code;
                } else {
                  profile.user_base.postal_code = "";
                }
                if (content.id_card) {
                  profile.user_base.id_card = content.id_card;
                } else {
                  profile.user_base.id_card = "";
                }
                if (content.birthplace) {
                  home = JSON.parse(content.birthplace).birthplace_code;
                } else {
                  home = [];
                }
              } else {
                profile.user_base.user_information_id = item.id;
              }
            }
            if (item.class === "user_evaluate") {
              if (content) {
                content.user_information_id = item.id;
                profile.user_evaluate = content;
              } else {
                profile.user_evaluate.user_information_id = item.id;
              }
            }
            if (
              item.class !== "user_base" ||
              item.class !== "user_evaluate" ||
              item.class !== "language_achievement_and_account_secrecy"
            ) {
              content.user_information_id = item.id;
            }
            if (item.class === "language_achievement_and_account_secrecy") {
              profile.language_achievement_and_account_secrecy.content =
                content.content;
              profile.language_achievement_and_account_secrecy.user_information_id =
                content.user_information_id;
            }
            if (item.class === "educational_background") {
              profile.educational_background.push(content);
            }
            // if (item.class === "exchange_experiences") {
            //   profile.exchange_experiences.push(content);
            // }
            if (item.class === "academic_projects") {
              if (!content.hidden_status) {
                content.hidden_status = 2
              }
              profile.academic_projects.push(content);
            }
            if (item.class === "work_experience") {
              if (!content.hidden_status) {
                content.hidden_status = 2
              }
              profile.work_experience.push(content);
            }
            if (item.class === "xiangmu_experience") {
              profile.xiangmu_experience.push(content)
            }
            if (item.class === "honorary_rewards") {
              if (!content.hidden_status) {
                content.hidden_status = 2
              }
              profile.honorary_rewards.push(content);
            }
            if (item.class === "extracurricular_activities") {
              if (!content.hidden_status) {
                content.hidden_status = 2
              }
              profile.extracurricular_activities.push(content);
            }
            if (item.class === "thesis") {
              profile.thesis.push(content);
            }
          });
          this.month('work_experience')
          this.month('academic_projects')
          this.month('honorary_rewards')
          this.month('extracurricular_activities')
          this.birthplace_arr = home;
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    delLanguageAchievementAndAccountSecrecyList(index) {
      const next = () => {
        this.profile.language_achievement_and_account_secrecy.content.splice(
          index,
          1
        );
      };
      this.checkMaterialsUploaded(
        this.profile.language_achievement_and_account_secrecy.content[index]
          .user_information_id,
        next,
        "language_achievement_and_account_secrecy"
      );
    },
    delEducationalBackground(index, item) {
      const next = () => {
        this.profile.educational_background.splice(index, 1);
      };
      this.checkMaterialsUploaded(
        this.profile.educational_background[index].user_information_id,
        next
      );
    },
    // delExchangeExperiences(index) {
    //   const next = () => {
    //     this.profile.exchange_experiences.splice(index, 1);
    //   };
    //   this.checkMaterialsUploaded(
    //     this.profile.exchange_experiences[index].user_information_id,
    //     next
    //   );
    // },
    delAcademicProjects(index) {
      const next = () => {
        this.profile.academic_projects.splice(index, 1);
      };
      this.checkMaterialsUploaded(
        this.profile.academic_projects[index].user_information_id,
        next
      );
    },
    delXiangmuExperience(index) {
      const next = () => {
        this.profile.xiangmu_experience.splice(index, 1);
      };
      this.checkMaterialsUploaded(
        this.profile.xiangmu_experience[index].user_information_id,
        next
      );
    },
    delWorkExperience(index) {
      const next = () => {
        this.profile.work_experience.splice(index, 1);
      };
      this.checkMaterialsUploaded(
        this.profile.work_experience[index].user_information_id,
        next
      );
    },
    delHonoraryRewards(index) {
      const next = () => {
        this.profile.honorary_rewards.splice(index, 1);
      };
      this.checkMaterialsUploaded(
        this.profile.honorary_rewards[index].user_information_id,
        next
      );
    },
    delThesis(index) {
      const next = () => {
        this.profile.thesis.splice(index, 1);
      };
      this.checkMaterialsUploaded(
        this.profile.thesis[index].user_information_id,
        next
      );
    },
    delExtracurricularActivities(index) {
      const next = () => {
        this.profile.extracurricular_activities.splice(index, 1);
      };
      this.checkMaterialsUploaded(
        this.profile.extracurricular_activities[index].user_information_id,
        next
      );
    },
    addLanguageAchievementAndAccountSecrecyList() {
      this.profile.language_achievement_and_account_secrecy.content.push({
        user_information_id: "",
        type: "",
        fraction: "",
      });
    },
    addEducationalBackground() {
      this.profile.educational_background.push({
        user_information_id: null,
        reading_status: "",
        stage: "",
        school: "",
        major: "",
        degree_type: "",
        time: [],
        ranking: "",
        gpa: "",
        sharing: "",
      });
    },
    // addExchangeExperiences() {
    //   this.profile.exchange_experiences.push({
    //     user_information_id: null,
    //     type: "",
    //     school: "",
    //     major: "",
    //     degree_type: "",
    //     time: [],
    //     gpa: "",
    //     sharing: "",
    //   });
    // },
    addAcademicProjects(index) {
      this.profile.academic_projects.push({
        user_information_id: null,
        type: "",
        name: "",
        describe: "",
        time: [],
        introduction: "",
        responsibility: "",
        methodology: "",
        outcome: "",
        competition_type: '',
        hidden_status: 2,
        fileList: []
      });
    },
    addXiangmuExperience(index) {
      this.profile.xiangmu_experience.push({
        user_information_id: null,
        corporation_name: "",
        corporation_ename: '',
        type: "",
        corporation_address: "",
        time: [],
        position: "",
        responsibility: "",
        company_address: '',
        hidden_status: 2,
      });
    },
    addWorkExperience(index) {
      this.profile.work_experience.push({
        user_information_id: null,
        corporation_name: "",
        corporation_ename: '',
        type: "",
        corporation_address: "",
        time: [],
        position: "",
        responsibility: "",
        company_address: '',
        hidden_status: 2,
      });
    },
    addHonoraryRewards() {
      this.profile.honorary_rewards.push({
        user_information_id: null,
        date: "",
        type: "",
        name: "",
        content: "",
        hidden_status: 2,
      });
    },
    addThesis() {
      this.profile.thesis.push({
        user_information_id: null,
        name: "",
        type: "",
        time: [],
        number: "",
      });
    },
    addExtracurricularActivities() {
      this.profile.extracurricular_activities.push({
        user_information_id: null,
        time: [],
        content: "",
        certificate: "",
        hidden_status: 2,
      });
    },
    handleClose(tag) {
      this.profile.user_evaluate.dynamicTags.splice(
        this.profile.user_evaluate.dynamicTags.indexOf(tag),
        1
      );
    },
    getBirthplace(value) {
      this.profile.user_base.birthplace = value;
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      var inputValue = this.inputValue;
      if (inputValue) {
        this.profile.user_evaluate.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
  },
  computed: {
    eduDesc: {
      get() {
        let data = this.$store.state.userAbroad.userAbroadBindData;
        if (
          data &&
          data.apply_academic_degree &&
          (data.apply_academic_degree.includes("硕士学位") ||
            data.apply_academic_degree.includes("博士学位"))
        ) {
          return "请添加专科及其以上的教育经历，并且包含目前在读";
        } else {
          return "请添加高中及其以上的教育经历，并且包含目前在读";
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.hb-user-profile-edit-page {
  .el-form-item {
    margin-bottom: 0 !important;
  }

  .submit-wrapper {
    margin-top: 20px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
}

.clear {
  clear: both;
}

.dynamicTags {
  margin-bottom: 1rem;
  border-bottom: 1px solid #dcdcdc;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  .my_content {
    flex: 1;
  }

  .icon {
    width: 50px;
    text-align: center;
    font-weight: 900;
    font-size: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_eleven.vue